export default "__VITE_ASSET__CZUQRcdL__"